import React from 'react';
import {Box, Button} from "@mui/material";
import {useTypedSelector} from "../../hooks/useTypeSelector";

import {
    ReactComponent as ExpandRightPanelIcon
} from "../../assets/flyerDetailsPopupAssets/expand_right_panel_icon.svg";
import {toggleFlyerRightPanel} from "../../store/actionCreators/toggleActionForEditorActionCreators";
import {useDispatch} from "react-redux";


interface Props {
    animationTime: number;
    setLoading: (value: boolean) => void;
}

const ExpandCollapseBtn: React.FC<Props> = ({
                                                animationTime,
                                                setLoading
                                            }) => {
    const dispatch = useDispatch();
    const {isShowRightPanel} = useTypedSelector((state) => state.toggleActionsForFlyers);


    const expandCollapseRightPanel = () => {
        dispatch(toggleFlyerRightPanel());
        setLoading(true);
        setTimeout(() => {
            setLoading(false)
        }, animationTime)
    }

    return (
        <Box
            sx={{
                display: 'flex',
                position: "absolute",
            }}
        >
            <Button onClick={expandCollapseRightPanel} sx={{
                position: 'absolute',
                top: "12px",
                left: "-14px",
                backgroundColor: "#014780",
                padding: "4px",
                zIndex: "4",
                "&:hover": {
                    backgroundColor: "#014780E6",
                }
            }}>
                <ExpandRightPanelIcon style={{
                    transform: isShowRightPanel ? "scaleX(-1)" : "none",
                    transition: `transform ${animationTime} ease-in`
                }}/>
            </Button>

        </Box>

    )
}

export default ExpandCollapseBtn;